/**
 * FunilWidget — Funil de situacoes de orcamento (RASCUNHO/EM_NEGOCIACAO/...).
 */
import React from "react";
import { Link } from "react-router-dom";

import { obterPainel } from "../../../services/comercialPainel";

import { CardBody, KpiSub, LinkLight, CardFooter } from "../styles";


export const meta = {
  id: "funil",
  label: "Funil de orçamentos",
  descricao: "Contagem de orçamentos por situação no periodo.",
  categoria: "Comercial",
  permissoes: ["comercial:metricas"],
  tamanho_default: "M",
  essencial: false,
};

export async function fetchData(request) {
  return await obterPainel(request);
}

const ORDEM = ["RASCUNHO", "EM_NEGOCIACAO", "APROVADO", "CONVERTIDO", "RECUSADO", "EXPIRADO"];

export function Widget({ dados }) {
  const funil = dados?.funil || {};
  // Pode vir como dict {situacao: count} ou lista
  const entries = ORDEM
    .map((s) => [s, funil[s] ?? funil[s.toLowerCase()] ?? 0])
    .filter(([, n]) => n > 0);
  const max = entries.reduce((m, [, n]) => Math.max(m, Number(n) || 0), 0) || 1;
  if (entries.length === 0) {
    return (
      <>
        <CardBody>
          <KpiSub>Nenhum orçamento no periodo.</KpiSub>
        </CardBody>
        <CardFooter>
          <LinkLight as={Link} to="/comercial/painel">Ver painel</LinkLight>
        </CardFooter>
      </>
    );
  }
  return (
    <>
      <CardBody>
        <ul style={{ listStyle: "none", padding: 0, margin: 0, display: "flex", flexDirection: "column", gap: 6 }}>
          {entries.map(([situacao, qtd]) => (
            <li key={situacao}>
              <div style={{ display: "flex", justifyContent: "space-between", fontSize: "0.82rem", marginBottom: 2 }}>
                <span>{situacao.replace("_", " ")}</span>
                <strong>{qtd}</strong>
              </div>
              <div style={{ height: 6, background: "var(--surface-2)", borderRadius: 3 }}>
                <div style={{
                  width: `${(qtd / max) * 100}%`,
                  height: "100%",
                  background: "var(--accent)",
                  borderRadius: 3,
                }} />
              </div>
            </li>
          ))}
        </ul>
      </CardBody>
      <CardFooter>
        <LinkLight as={Link} to="/comercial/painel">Ver painel</LinkLight>
      </CardFooter>
    </>
  );
}
